import { Fragment, useMemo, useState } from "react";
import { requestStatus } from "../../../../../constants/statusConstants";
import Progress, { ApprovedDate, Assignee, Content2, CreatedDate } from "../../../components/Progress";
import ProgressLayout from "../../../components/layout/ProgressLayout";
import { useProcess } from "../../../process-context";
import { getStepClassByStatus, getStepIconByStatus } from "../../../util";
import { Button } from "react-bootstrap";
import FontFa from "../../../../../components/fontFa/fontFa";
import EditRepairToolsModal from "../../../modal/edit-repair-tool";
import { ExtraStateContext } from ".";
import { useSelector } from "../../../../../store/store";
import ViewHistoryEditRepairToolsModal from "../../../modal/view-history-update-repair";
import { PinLayout } from "../../../components/layout/PinsLayout";
import { useUpdateRTR } from "../hooks/use-update-RTR";

const ItRepairToolProgress = () => {
  const { Request } = useProcess<ExtraStateContext>();
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [isOpenViewHistoryModal, setIsOpenViewHistoryModal] = useState(false);
  const [payload, setPayload] = useState<{ id?: string; fields?: string; date?: Date }>({});
  const [historyId, setHistoryId] = useState("");

  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;
  const admin = [
    "thiennv@viags.vn",
    "trungdt@viags.vn",
    "canbo1@viags.vn",
    "hieppt@viags.vn",
    "phuocvd@viags.vn",
    "hantt@viags.vn",
    "lapdt@viags.vn",
    "quynhvtn@viags.vn",
    "trungnn@viags.vn",
  ];
  const isAdmin = admin.includes(currentUserName?.toLowerCase());
  const { updateRTRequest } = useUpdateRTR();

  const progressData = useMemo(() => {
    const { fields, createdDateTime } = Request;

    const onEditModalOpen = (payload: { id?: string; fields?: string; date?: Date }) => {
      setIsOpenEditModal(true);
      setPayload(payload);
    };

    const onViewHistoryModalOpen = (id: string) => {
      setIsOpenViewHistoryModal(true);
      setHistoryId(id);
    };

    const {
      eApprovedStatus,
      eAssigneeStatusDate,
      eApprovedByITHeadStatus,
      eApprovedBy,
      eApprovedDate,
      eApprovedByITHead,
      eApprovedByITHeadDate,
      eAssignee,
      eAssigneeStatus,
      eCreatedDate,
      eCreateName,
    } = fields;

    return [
      {
        iconName: "faCheck",
        stepClassName: "approved",
        hidden: false,
        Content: (
          <Content2
            renderRank={<Content2.Rank>Khởi tạo</Content2.Rank>}
            renderTitle={
              <Fragment>
                <Content2.Title>{eCreateName ? eCreateName : Request.createdBy.user.displayName}</Content2.Title>
                <Content2.Title>{Request.createdBy.user.email}</Content2.Title>
                <Content2.JobTitle>{Request.fields.ePhoneNumber ? Request.fields.ePhoneNumber : ""}</Content2.JobTitle>
              </Fragment>
            }
            renderTime={
              <Content2.Time>
                <CreatedDate value={eCreatedDate ? eCreatedDate : createdDateTime} />
                {isAdmin && (
                  <>
                    <Button
                      onClick={() =>
                        onEditModalOpen({
                          id: "created",
                          fields: "eCreatedDate",
                          date: eCreatedDate ? eCreatedDate : createdDateTime,
                        })
                      }
                      variant="outline"
                      className="mb-1"
                      title="Chỉnh sửa ngày tạo"
                      style={{ boxShadow: "none" }}
                    >
                      <FontFa name="faEdit" size="sm" color="#ffcc00" />
                    </Button>
                    <Button
                      onClick={() => onViewHistoryModalOpen("created")}
                      variant="outline"
                      className="mb-1"
                      title="Xem lịch sử chỉnh sửa"
                      style={{ boxShadow: "none", padding: "0" }}
                    >
                      <FontFa name="faHistory" size="sm" color="#34e5eb" />
                    </Button>
                  </>
                )}
              </Content2.Time>
            }
          />
        ),
      },
      {
        iconName: getStepIconByStatus(eApprovedStatus),
        stepClassName: getStepClassByStatus(eApprovedDate, eApprovedStatus),
        hidden: !eApprovedBy,
        Content: (
          <Content2
            renderRank={<Content2.Rank>Cán bộ CNTT</Content2.Rank>}
            renderTitle={
              <Fragment>
                <Content2.Title>{eApprovedBy.split("|")[1]}</Content2.Title>
                <Content2.Title>{eApprovedBy.split("|")[0]}</Content2.Title>
                <Content2.JobTitle>{eApprovedBy.split("|")[2]}</Content2.JobTitle>
              </Fragment>
            }
            renderTime={
              <Content2.Time>
                <ApprovedDate value={eApprovedDate} />
                {isAdmin && eApprovedDate && (
                  <>
                    <Button
                      onClick={() => onEditModalOpen({ id: "approve", fields: "eApprovedDate", date: eApprovedDate })}
                      variant="outline"
                    >
                      <FontFa name="faEdit" size="sm" color="#ffcc00" />
                    </Button>
                    <Button
                      onClick={() => onViewHistoryModalOpen("approve")}
                      variant="outline"
                      className="mb-1"
                      title="Xem lịch sử chỉnh sửa"
                      style={{ boxShadow: "none", padding: "0" }}
                    >
                      <FontFa name="faHistory" size="sm" color="#34e5eb" />
                    </Button>
                  </>
                )}
              </Content2.Time>
            }
          />
        ),
      },
      // {
      //   iconName: getStepIconByStatus(eApprovedByITLeadStatus),
      //   stepClassName: getStepClassByStatus(eApprovedByITLeadDate, eApprovedByITLeadStatus),
      //   hidden: !eApprovedByITLead,
      //   Content: (
      //     <Content2
      //       renderRank={<Content2.Rank>Xác nhận của CQ/ĐV</Content2.Rank>}
      //       renderTitle={
      //         <Fragment>
      //           <Content2.Title>{eApprovedByITLead.split("|")[1]}</Content2.Title>
      //           <Content2.Title>{eApprovedByITLead.split("|")[0]}</Content2.Title>
      //           <Content2.JobTitle>{eApprovedByITLead.split("|")[2]}</Content2.JobTitle>
      //         </Fragment>
      //       }
      //       renderTime={
      //         <Content2.Time>
      //           <ApprovedDate value={eApprovedByITLeadDate} />
      //           {isAdmin && eApprovedByITLeadDate &&(
      //           <>
      //             <Button onClick={() => onEditModalOpen({id: 'itlead', fields: 'eApprovedByITLeadDate', date: eApprovedByITLeadDate})} variant="outline"><FontFa name="faEdit" size="sm" color="#ffcc00"/></Button>
      //             <Button onClick={() => onViewHistoryModalOpen('itlead')} variant="outline" className="mb-1" title="Xem lịch sử chỉnh sửa" style={{boxShadow: 'none', padding: '0'}}><FontFa name="faHistory" size="sm" color="#34e5eb"/></Button>
      //           </>)}
      //         </Content2.Time>
      //       }
      //     />
      //   ),
      // },
      {
        iconName: getStepIconByStatus(eApprovedByITHeadStatus),
        stepClassName: getStepClassByStatus(eApprovedByITHeadDate, eApprovedByITHeadStatus),
        hidden: !eApprovedByITHead,
        Content: (
          <Content2
            renderRank={<Content2.Rank>CNTT thực hiện</Content2.Rank>}
            renderTitle={
              <Fragment>
                <Content2.Title>{eApprovedByITHead.split("|")[1]}</Content2.Title>
                <Content2.Title>{eApprovedByITHead.split("|")[0]}</Content2.Title>
                <Content2.JobTitle>{eApprovedByITHead.split("|")[2]}</Content2.JobTitle>
              </Fragment>
            }
            renderTime={
              <Content2.Time>
                <ApprovedDate
                  value={eApprovedByITHeadDate}
                  placeholder={<span className="flag default">Chưa thực hiện</span>}
                />
                {isAdmin && eApprovedByITHeadDate && (
                  <>
                    <Button
                      onClick={() =>
                        onEditModalOpen({ id: "ithead", fields: "eApprovedByITHeadDate", date: eApprovedByITHeadDate })
                      }
                      variant="outline"
                    >
                      <FontFa name="faEdit" size="sm" color="#ffcc00" />
                    </Button>
                    <Button
                      onClick={() => onViewHistoryModalOpen("ithead")}
                      variant="outline"
                      className="mb-1"
                      title="Xem lịch sử chỉnh sửa"
                      style={{ boxShadow: "none", padding: "0" }}
                    >
                      <FontFa name="faHistory" size="sm" color="#34e5eb" />
                    </Button>
                  </>
                )}
              </Content2.Time>
            }
          />
        ),
      },
      {
        iconName: getStepIconByStatus(eAssigneeStatus),
        stepClassName: getStepClassByStatus(eAssigneeStatusDate, eAssigneeStatus),
        hidden: !eAssignee,
        Content: (
          <Content2
            renderRank={<Content2.Rank>CQ/ĐV nghiệm thu</Content2.Rank>}
            renderTitle={
              <Fragment>
                <Content2.Title>{eAssignee.split("|")[1]}</Content2.Title>
                <Content2.Title>{eAssignee.split("|")[0]}</Content2.Title>
              </Fragment>
            }
            renderTime={
              <Content2.Time>
                <Assignee>
                  <Assignee.Date value={eAssigneeStatusDate} />
                  <Assignee.Status assigneeStatus={eAssigneeStatus} requestStatus={requestStatus} />
                </Assignee>
                {isAdmin && eAssigneeStatusDate && (
                  <>
                    <Button
                      onClick={() =>
                        onEditModalOpen({ id: "assignee", fields: "eAssigneeStatusDate", date: eAssigneeStatusDate })
                      }
                      variant="outline"
                    >
                      <FontFa name="faEdit" size="sm" color="#ffcc00" />
                    </Button>
                    <Button
                      onClick={() => onViewHistoryModalOpen("assignee")}
                      variant="outline"
                      className="mb-1"
                      title="Xem lịch sử chỉnh sửa"
                      style={{ boxShadow: "none", padding: "0" }}
                    >
                      <FontFa name="faHistory" size="sm" color="#34e5eb" />
                    </Button>
                  </>
                )}
              </Content2.Time>
            }
          />
        ),
      },
    ];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Request]);

  const onEditModalClose = () => {
    setIsOpenEditModal(!isOpenEditModal);
  };

  const onViewHistoryModalClose = () => {
    setIsOpenViewHistoryModal(!isOpenViewHistoryModal);
  };

  const handleDateChange = async (date: Date) => {
    const historyList = Request.fields.eUpdateHistory ? JSON.parse(Request.fields.eUpdateHistory) : [];
    const createdHistory = {
      id: payload.id,
      value: date,
      modifiedDate: new Date(),
      user: user.current.name,
    };
    historyList.push(createdHistory);
    const fields = {
      [payload.fields!]: date,
      eUpdateHistory: JSON.stringify(historyList),
    };
    updateRTRequest(
      { id: Request.id, body: fields },
      { successText: "Chỉnh sửa ngày tạo thành công", errorText: "Chỉnh sửa ngày tạo thất bại" },
    );
  };

  return (
    <>
      <ProgressLayout>
        <Progress
          title={
            <span>
              Quy trình duyệt - yêu cầu {Request.id} <PinLayout />
            </span>
          }
          data={progressData}
          getStepIcon={(item) => item.iconName}
          getStepClassName={(item) => item.stepClassName}
          getStepHidden={(item) => item.hidden}
          renderContent={(item) => item.Content}
        />
      </ProgressLayout>
      <EditRepairToolsModal
        isOpen={isOpenEditModal}
        onClose={onEditModalClose}
        onDateChange={handleDateChange}
        value={payload.date}
        isShowTime={true}
      />
      <ViewHistoryEditRepairToolsModal
        isOpen={isOpenViewHistoryModal}
        onClose={onViewHistoryModalClose}
        value={Request.fields.eUpdateHistory}
        id={historyId}
      />
    </>
  );
};

export default ItRepairToolProgress;
